<template lang='pug'>
Progress(
  v-slot='{ start, stop }'
)
  Event(
    v-if='month'
    @event='stop'
  )
  FatSecret(
    @start='start'
    @stop='setMonth'
    v-slot='{ weightsGetMonth }'
  )
    Event(
      @event='weightsGetMonth({ date: date_int })'
    )
  v-simple-table
    template(
      v-slot:default
    )
      tbody
        tr(
          v-for='day in days'
        )
          td
            | {{ day[0] }}
          td.text-right
            | {{ day[1] }}
</template>

<script>
import { castArray, compact, cond, eq, get, identity, map, over, pipe, reverse, stubTrue, wrap } from 'lodash/fp';

import { date_int_to_date } from '@thomasphan/helpers-fatsecret';

import Event from './Event.vue';
import FatSecret from './FatSecret.vue';
import Progress from './Progress.vue';

import { stringToNumber } from '../functions/stringToNumber';

const setMonth = function (response)
{
  this.month = response?.data?.month;

  this.$emit('update:days', this?.days);
};

const days = function ()
{
  const weight_type = this?.$store?.state?.weight_type_module?.weight_type;

  const kgToLb = function (kg)
  {
    return window.Number(kg) * 2.2046226218;
  };

  const round = function (num)
  {
    return window.Number(num).toFixed(1);
  };

  return pipe
  ([
    castArray,
    compact,
    reverse,
    map
    (
      over
      ([
        pipe
        ([
          get('date_int'),
          stringToNumber,
          date_int_to_date,
        ]),
        pipe
        ([
          get('weight_kg'),
          stringToNumber,
          cond
          ([
            [wrap(eq('kg'))(weight_type), identity],
            [stubTrue, kgToLb],
          ]),
          round,
        ]),
      ])
    ),
  ])
  (this?.month?.day);
};

export default
{
  components:
  {
    Event,
    FatSecret,
    Progress,
  },
  computed:
  {
    days
  },
  data()
  {
    return {
      month: null
    };
  },
  methods:
  {
    setMonth
  },
  props:
  {
    date_int: { required: true }
  },
};
</script>